import {
  ProductCard_default,
  clsx_default
} from "./chunk--chunk-65SBUQCI.vbt.js";
import {
  CacheProvider,
  css,
  jsx,
  require_classnames,
  useTheme
} from "./chunk--chunk-SVHRWCYL.vbt.js";
import {
  _,
  init_preact_module,
  k
} from "./chunk--chunk-WOOXM6XY.vbt.js";
import {
  __toESM
} from "./chunk--chunk-Z7A6LSGX.vbt.js";

// src/js/searchspring/Autocomplete/Content.jsx
init_preact_module();
var locales = JSON.parse(
  document.querySelector("[data-searchspring][data-locales]").getAttribute("data-locales")
);
var Content = (props) => {
  const {
    controller: {
      acContentController: {
        store: { results }
      }
    },
    contentTitle,
    articlesTitle,
    input
  } = props;
  return props.results.length > 0 ? /* @__PURE__ */ _(k, null, /* @__PURE__ */ _("h3", { class: "pt-[26px] pb-[8px] lg:pb-[26px] font-primary text-[12px] lg:text-[14px] tracking-[.2px] text-gray-dark ml-[20px] lg:ml-[63px] uppercase" }, contentTitle), /* @__PURE__ */ _(
    "ul",
    {
      className: clsx_default(
        "flex flex-nowrap gap-4 lg:gap-8 overflow-x-auto scrollbar-thin",
        "scrollbar-thumb-[#B5B5B5] scrollbar-track-[#F7F7F6]",
        "scrollbar-track-rounded-full scrollbar-thumb-rounded-full",
        "pl-[20px] lg:pl-0 ml-0 lg:ml-[63px] pr-[16px]",
        "scrollbar-w-[7px] scrollbar-h-[7px]"
      )
    },
    props.results.map((result) => /* @__PURE__ */ _("li", { className: "flex-[0_0_166px] lg:flex-[0_0_275px]" }, /* @__PURE__ */ _(ProductCard_default, { result, input })))
  ), /* @__PURE__ */ _("h3", { class: "border-gray-lightest pt-[26px] pb-[8px] lg:pb-[26px] font-primary text-[12px] lg:text-[14px] tracking-[.2px] text-gray-dark ml-[20px] lg:ml-[63px] uppercase" }, articlesTitle), /* @__PURE__ */ _("ul", { className: "flex flex-col lg:grid grid-rows-2 grid-cols-2 lg:gap-y-6 gap-x-16 pb-16 mx-[20px] lg:mx-[63px]" }, results.map((result, i) => {
    if (i < 4) {
      return /* @__PURE__ */ _(
        "li",
        {
          className: clsx_default(
            "border-gray-lightest",
            i === 0 ? "border-y" : "border-b lg:border-t"
          )
        },
        /* @__PURE__ */ _(
          AutocompleteContentResult,
          {
            result,
            input,
            isFirst: i === 0
          }
        )
      );
    }
  }))) : /* @__PURE__ */ _("p", { className: "px-[20px] font-primary text-[1.14286rem] leading-[1.5] text-gray-light flex flex-col gap-4 mt-4 pb-[1.5rem] border-b border-gray-lightest" }, /* @__PURE__ */ _("span", null, locales.autocomplete_no_results.replace(
    "{{terms}}",
    props.input.value
  )), /* @__PURE__ */ _("span", null, locales.autocomplete_try_another));
};
var AutocompleteContentResult = (props) => {
  const {
    result: {
      mappings: {
        core: { imageUrl, name, url }
      }
    },
    isFirst
  } = props;
  return /* @__PURE__ */ _(
    "a",
    {
      target: "_blank",
      className: clsx_default(
        "h-full flex flex-col lg:grid grid-cols-2 py-8 first:pt-0 only:pt-8",
        props.source === "product-grid" ? "items-start gap-[2rem]" : "items-center"
      ),
      href: url
    },
    /* @__PURE__ */ _("div", { className: "col-start-1 rounded-[10px] overflow-hidden w-full h-auto lg:h-full" }, /* @__PURE__ */ _(
      "img",
      {
        height: 50,
        width: 50,
        className: `${props.source === "product-grid" ? "w-full aspect-auto h-auto" : "w-full h-auto lg:h-full object-cover"}`,
        src: imageUrl
      }
    )),
    /* @__PURE__ */ _("div", { className: "col-start-2 pt-5 lg:p-5 flex flex-col gap-1 justify-evenly" }, /* @__PURE__ */ _(
      "h3",
      {
        className: "text-[1.3rem] lg:text-h2-mob font-special lg:mb-[20px]",
        dangerouslySetInnerHTML: { __html: name }
      }
    ), /* @__PURE__ */ _("p", { className: "text-caption lg:text-p font-primary underline uppercase" }, locales.read_now))
  );
};

// node_modules/@searchspring/snap-preact-components/dist/esm/types.js
var Layout;
(function(Layout2) {
  Layout2["GRID"] = "grid";
  Layout2["LIST"] = "list";
})(Layout || (Layout = {}));
var FacetType;
(function(FacetType2) {
  FacetType2["VALUE"] = "value";
  FacetType2["RANGE"] = "range";
  FacetType2["RANGE_BUCKETS"] = "range-buckets";
})(FacetType || (FacetType = {}));
var FacetDisplay;
(function(FacetDisplay2) {
  FacetDisplay2["GRID"] = "grid";
  FacetDisplay2["PALETTE"] = "palette";
  FacetDisplay2["LIST"] = "list";
  FacetDisplay2["SLIDER"] = "slider";
  FacetDisplay2["HIERARCHY"] = "hierarchy";
})(FacetDisplay || (FacetDisplay = {}));

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Atoms/Merchandising/InlineBanner/InlineBanner.js
init_preact_module();
var import_classnames = __toESM(require_classnames());
var CSS = {
  inlineBanner: ({ width }) => css({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width,
    "&.ss__inline-banner--grid": {
      flexDirection: "column"
    },
    "&.ss__inline-banner--list": {
      flexDirection: "row",
      display: "block",
      width: "100%"
    },
    "& iframe": {
      maxWidth: "100%"
    }
  })
};
function InlineBanner(properties) {
  const globalTheme = useTheme();
  const props = {
    // default props
    layout: Layout.GRID,
    width: "auto",
    // global theme
    ...globalTheme?.components?.inlineBanner,
    // props
    ...properties,
    ...properties.theme?.components?.inlineBanner
  };
  const { banner, disableStyles, className, width, layout, onClick, style } = props;
  const styling = {};
  if (!disableStyles) {
    styling.css = [CSS.inlineBanner({ width }), style];
  } else if (style) {
    styling.css = [style];
  }
  return banner && banner.value ? jsx(
    CacheProvider,
    null,
    jsx("div", { onClick: (e) => {
      onClick && onClick(e, banner);
    }, className: (0, import_classnames.default)("ss__inline-banner", `ss__inline-banner--${layout}`, className), ...styling, dangerouslySetInnerHTML: {
      __html: banner.value
    } })
  ) : jsx(k, null);
}

export {
  Layout,
  FacetDisplay,
  InlineBanner,
  Content,
  AutocompleteContentResult
};
